
<section class="container-fluid">
  <transition name="fade">
    <router-view></router-view>
  </transition>
</section>
